import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useTheme from "../hooks/useTheme";
import JujuyPage from "./projects/JujuyPage";
import LopezJordanPage from "./projects/LopezJordanPage";

export enum FixedProjects {
    JUJUY = "jujuy",
    LOPEZ_JORDAN = "lopez-jordan"
}

const ProjectsPage = () => {
    const { changeTheme } = useTheme()
    const { pathname } = useLocation()
    const project = pathname.split("/").pop()
    const selectedProject = project === FixedProjects.JUJUY ? FixedProjects.JUJUY
        : FixedProjects.LOPEZ_JORDAN

    useEffect(() => {
        changeTheme("light")
    }, [])

    return (
        <section className="bg-white">
            {selectedProject === FixedProjects.JUJUY && <JujuyPage />}
            {selectedProject === FixedProjects.LOPEZ_JORDAN && <LopezJordanPage />}
        </section>
    );
};

export default ProjectsPage;
